import React, { useState, memo, useRef } from "react";
import Formsy from "formsy-react";
// import { MySelect } from "../../Shared/Forms/Select";
import { TextInput } from "../../Shared/Forms";
import { Row, Col, Button, Spinner, UncontrolledAlert } from "reactstrap";
import { MdSave } from "react-icons/md";
import { UploadFile } from "../../Shared/FileUpLoad";

import { upLoadService } from "../../Shared/Forms/UploadImageService";

const GeneralMealForm = memo((props) => {
    const { submitted, submitting, imageUrl, setImageNull, handleSubmit, formError } = props;
    const mealFormRef = useRef("generalMealForm");

    const [generalImageUrl, setGeneralImageUrl] = useState({ key: "imageUrl", value: null });
    const [imageUploaded, setImageUploaded] = useState(false);
    // validation states
    const [canSubmit, setCanSubmit] = useState(false);
    const [isUpLoading, setIsUpLoading] = useState(false);
    const [uploadingSubmitting, setUploadingSubmitting] = useState(false);

    //image error handling..
    const [imageUploadError, setImageUploadError] = useState(null);
    const cancelImageUploadingSetting = () => {
        setImageUploaded(false);
    };
    const uploadImageToCloud = async (data) => {
        setCanSubmit(false);
        setUploadingSubmitting(true);

        try {
            let response = await upLoadService.submitImage(data);
            if (response && response.imageUrl) {
                setUploadingSubmitting(false);
                setIsUpLoading(false);
                setCanSubmit(true);
                setGeneralImageUrl({ key: "imageUrl", value: response.imageUrl });
                setImageUploaded(true);
            }
        } catch (error) {
            setImageUploadError(error);
            setUploadingSubmitting(false);
            setImageUploaded(false);
        }
    };

    const submitGeneralMealPlan = (e) => {
        //please don't forget to parse the string to float
        try {
            if (e) {
                let refineData = { name: e.name, description: e.description, calories: parseFloat(e.calories), durationDays: parseInt(e.durationDays), imageUrl: generalImageUrl && generalImageUrl.value };

                handleSubmit(refineData);
            }
        } catch (e) {
            console.error(e);
        }
    };

    const enableButton = () => {
        setCanSubmit(true);
    };
    const disableButton = () => {
        setCanSubmit(false);
    };

    const uploadingToCloud = (imageData) => {
        let newImageData = imageData && imageData.substr(22);
        setIsUpLoading(true);
        uploadImageToCloud({ base64Image: newImageData });
    };
    const cancelUploadedImageUrl = () => {
        setGeneralImageUrl({ key: "imageUrl", value: null });
    };
    return (
        <React.Fragment>
            <Formsy ref={mealFormRef} onValidSubmit={submitGeneralMealPlan} onValid={enableButton} onInvalid={disableButton} noValidate>
                {formError && !formError.errors ? <UncontrolledAlert color="danger">{formError.message}</UncontrolledAlert> : null}
                {formError && formError.errors && formError.formError.length ? (
                    <UncontrolledAlert color="danger">
                        {formError.errors.map((error, index) => (
                            <p key={index}>{error.message}</p>
                        ))}
                    </UncontrolledAlert>
                ) : null}
                <Row>
                    <Col sm="5">
                        <TextInput
                            name="name"
                            required
                            title="Name"
                            validations={{
                                minLength: 3,
                                maxLength: 50,
                            }}
                            validationErrors={{
                                minLength: "Minimum of 3 characters allowed",
                                maxLength: "Maximum of 50 characters allowed",
                            }}
                        />
                        <TextInput
                            name="description"
                            required
                            title="Description"
                            validations={{
                                minLength: 5,
                            }}
                            validationErrors={{
                                minLength: "Minimum of 5 characters allowed",
                                maxLength: "Maximum of 50 characters allowed",
                            }}
                        />
                        <TextInput
                            name="calories"
                            required
                            title="Calories (Kcals)"
                            validations={{
                                isNumeric: true,
                            }}
                            validationErrors={{
                                isNumeric: "Whole numbers or decimals numbers only allowed",
                            }}
                        />
                        {!submitted ? (
                            <Button type="submit" color="primary" disabled={!canSubmit || submitting} className="pp3 mr-1">
                                {submitting ? (
                                    <Spinner size="sm" />
                                ) : (
                                    <span>
                                        {"Save"} <MdSave size={20} />
                                    </span>
                                )}
                            </Button>
                        ) : null}
                    </Col>
                    <Col sm="7">
                        <div style={{ width: "74%" }}>
                            <TextInput
                                name="durationDays"
                                required
                                title="Duration (Day(s))"
                                validations={{
                                    matchRegexp: /^[1-9][0-9]*$/,
                                }}
                                validationErrors={{
                                    matchRegexp: "Whole numbers numbers only allowed",
                                }}
                            />
                        </div>

                        <div style={{ paddingTop: "1rem" }}>
                            <UploadFile
                                name="imageUrl"
                                type="file"
                                acceptedFormats={"jpg|jpeg|png"}
                                disabled={submitting}
                                value={imageUrl || null}
                                maxSize={1048576}
                                imageUrl={imageUrl}
                                setImageNull={setImageNull}
                                isUpLoading={isUpLoading}
                                uploadToServer={true}
                                uploadingToCloud={uploadingToCloud}
                                imageUploadError={imageUploadError}
                                cancelUploadedImageUrl={cancelUploadedImageUrl}
                                submitting={uploadingSubmitting}
                                isImageUpLoaded={imageUploaded}
                                cancelImageUploadingSetting={cancelImageUploadingSetting}
                                required
                            />
                        </div>
                    </Col>
                </Row>
            </Formsy>
        </React.Fragment>
    );
});

export default GeneralMealForm;
